import React from 'react';

export default function FinanceIcon() {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M2 6C2 5.64638 2.14048 5.30724 2.39052 5.05719C2.64057 4.80714 2.97971 4.66667 3.33333 4.66667H12.6667C13.0203 4.66667 13.3594 4.80714 13.6095 5.05719C13.8595 5.30724 14 5.64638 14 6M2 7.33333H4C4.53333 7.33333 5.06667 7.53333 5.4 7.93333L6.13333 8.53333C7.2 9.6 8.86667 9.6 9.93333 8.53333L10.6667 7.93333C11 7.6 11.5333 7.33333 12.0667 7.33333H14M3.33333 2H12.6667C13.403 2 14 2.59695 14 3.33333V12.6667C14 13.403 13.403 14 12.6667 14H3.33333C2.59695 14 2 13.403 2 12.6667V3.33333C2 2.59695 2.59695 2 3.33333 2Z'
        stroke='url(#paint0_linear_1658_894)'
        strokeWidth='1.25'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <defs>
        <linearGradient
          id='paint0_linear_1658_894'
          x1='1.90728'
          y1='-0.465605'
          x2='10.6184'
          y2='12.3028'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' />
          <stop offset='1' stopColor='white' stopOpacity='0.65' />
        </linearGradient>
      </defs>
    </svg>
  );
}
